import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from './PopupHeader.styled';

const PopupHeaderComponent = ({ title }) => {
  return (
    <PopupHeader>
      <PopupHeaderStart/>
      <PopupHeaderTitle>
        {title}
      </PopupHeaderTitle>
      <PopupHeaderEnd />
      <PopupHeaderStart/>
    </PopupHeader>
  );
};

export default PopupHeaderComponent;
